<template>
  <b-form>
    <section class="d-flex flex-row justify-content-center mb-4">
      <avatar
        v-if="selectedUserType === USER_TYPES.CHILD"
        :avatar-bank="avatarImagesBank"
        :currentAvatar="informationToBeUpdated.selectedAvatar"
        @selectAvatar="selectAvatar"
        class="avatarSelector"
        ref="avatar"
      />
    </section>
    <b-form-group id="name" label="Name:" label-for="Name">
      <input
        v-model="informationToBeUpdated.name"
        placeholder="Enter name"
        class="atm-input w-100"
      />
    </b-form-group>
    <b-form-group id="lastName" label="Last Name:" label-for="Enter last name">
      <input
        v-model="informationToBeUpdated.lastName"
        placeholder="Enter last name"
        class="atm-input w-100"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import { USER_TYPES } from '@/common/utils';
import Avatar from '@/common/components/Avatar';

export default {
  components: {
    Avatar,
  },
  props: {
    informationToBeUpdated: { type: Object, required: true },
    avatarImagesBank: { type: Array, required: true },
    selectedUserType: { type: String, required: true },
  },
  data() {
    return {
      USER_TYPES,
    };
  },
  methods: {
    selectAvatar(avatarData) {
      this.informationToBeUpdated.selectedAvatar = avatarData;
    },
  },
};
</script>

<style lang="scss" scoped></style>
